export default class AbweichenderZahlungsempfaenger {
    // BT-59
    name = ""
    // BT-60
    kennung = ""
    // BT-60-1
    kennungSchema = ""
    // BT-61
    handelsregisterNr = ""
    // BT-61-1
    handelsregisterNrSchema = ""
}
